import React from 'react';
import { motion } from 'framer-motion';
import glyProdBG from '../images/prod_ngs/TheraDermBackgroundPictures-05.png';
import frag_glyc75 from '../images/products/THERADERM PRODUCTS FINAL RENDER/PERFUMED GLYCERIN 75ML.png';
import frag_glyc200 from '../images/products/THERADERM PRODUCTS FINAL RENDER/PERFUMED GLYCERIN 200ML.png';
import frag_glyc500 from '../images/products/THERADERM PRODUCTS FINAL RENDER/PERFUMED GLYCERIN 500ML.png';

function FragranceGlycerin() {
  const glycerinVariants = [frag_glyc75, frag_glyc200, frag_glyc500];

  return (
    <div>
      {/* Header Section */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="py-12 text-center"
      >
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-2 font-serif">
          PERFUMED GLYCERIN
        </h1>
        <div className="w-48 h-1 bg-pink-500 mx-auto mb-4"></div>
        <p className="text-pink-300 text-lg md:text-xl uppercase tracking-wider">
          Slightly Perfumed
        </p>
      </motion.div>

      {/* Product Section */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="relative overflow-hidden my-8 mx-auto max-w-6xl rounded-xl shadow-lg border-l-4 border-pink-500"
        style={{
          backgroundImage: `url(${glyProdBG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 relative z-10">
          {/* Product Info (Left) */}
          <div className="flex flex-col justify-center p-6 lg:p-8 text-white order-1">
            <motion.h2
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-2xl md:text-3xl font-bold mb-4 text-center lg:text-left"
            >
              Perfumed Body Glycerin
            </motion.h2>

            <motion.p
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="text-white/90 mb-6 text-center lg:text-left text-sm md:text-base"
            >
              <span className="text-pink-300 font-semibold">THERA DERM's Perfumed Glycerin</span>, softens and deeply moisturizes the skin, leaving it protected with a delicate fragrance.
            </motion.p>

            <motion.div
              initial={{ x: -20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="text-center lg:text-left italic text-lg font-serif"
            >
              "For <span className="text-pink-300">silky skin</span> with a touch of <span className="text-pink-300">fragrance</span>"
            </motion.div>
          </div>

          {/* Image Gallery (Right) */}
          <div className="flex flex-col items-center justify-center p-6 lg:p-8 order-2">
            <div className="flex items-end justify-center space-x-4 md:space-x-6">
              {glycerinVariants.map((img, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ scale: 1.03 }}
                  className="transition-all duration-300"
                >
                  <img
                    src={img}
                    alt={`Perfumed Glycerin ${idx === 0 ? '75ml' : idx === 1 ? '200ml' : '500ml'}`}
                    className={`w-${idx === 0 ? '16 md:w-20 lg:w-24' : idx === 1 ? '20 md:w-24 lg:w-28' : '24 md:w-28 lg:w-32'} h-auto object-contain drop-shadow-lg`}
                  />
                </motion.div>
              ))}
            </div>
            <div className="mt-4 text-center">
              <p className="text-white text-sm bg-black/30 px-3 py-1 rounded-full">
                Available in <span className="text-pink-300">75ml</span>,{' '}
                <span className="text-pink-300">200ml</span> &{' '}
                <span className="text-pink-300">500ml</span>
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default FragranceGlycerin;
